import React, { useState, useEffect } from "react";
import { Form, message } from "antd";
import Group from "../../../imgs/Group.svg";
import postIcon from "../../../imgs/post.svg";
import arrowTick from "../../../imgs/arrowTick.svg";
import { Select } from "antd";
import departmentIcon from "../../../imgs/departmenticon.svg";
import { CREATE_OFFER } from "./../../../graphql/mutations/offers";
import { useSelector } from "react-redux";
import { gql, useMutation } from "@apollo/client";

const IntroModal = ({ handleCancel, bounty }) => {
  const [relation, setRelation] = useState("");
  const [intro, setIntro] = useState("");
  const [comment, setComment] = useState("");
  const [disable, setDisable] = useState(true);
  const [offerCreated, setOfferCreated] = useState(false);
  const [createdError, setCreatedError] = useState("");

  const userProfile = useSelector((state) => state.strapiRes);
  const [createOffer] = useMutation(gql(CREATE_OFFER));

  const {
    fullName,
    company,
    title,
    bountyType,
    demandPrice,
    department,
    reason,
  } = bounty;

  const submitIntro = () => {
    createOffer({
      variables: {
        introPerson: userProfile.id,
        bountyId: bounty.id,
        introTime: intro,
        relation,
        comment,
      },
    })
      .then((resp) => {
        setOfferCreated(true);
      })
      .catch((err) => {
        message.error(err.message)
        setCreatedError("internal server error, try latter");
      });
  };

  useEffect(() => {
    comment && relation && intro ? setDisable(false) : setDisable(true);
  }, [comment, relation, intro]);

  return (
    <div className="home-modal-wrapper">
      {offerCreated && !createdError ? (
        <div className="heading-modal p-4">
          <div className="modal-container">
            <div className="main">
              <div className="mainn">
                <div className="icon">
                  <img src={arrowTick} alt="Tick" className="icon" />
                </div>
                <div className="content-body">
                  <h1 className="main-head">Submitted successfully</h1>
                  <p className="first-para">
                    You will be notified when the buyer makes a decision.
                  </p>
                  <p className="second-para">
                    You can find your applications in your
                    <span className="black"> {" "}
                      <u>dashboard.</u>
                    </span>
                  </p>
                </div>
              </div>
              <button className="btn" onClick={handleCancel}>
                Done
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div>
          <div className="heading-modal p-4">
            <div>
              <div className="row m-0 justify-content-between">
                <h2 className="heading">
                  <img
                    src={bountyType == "person" ? postIcon : departmentIcon}
                    alt="logo"
                  />
                  {bountyType == "person" ? fullName : company}
                </h2>
                <h2 className="small-heading">${demandPrice}</h2>
              </div>
              <p className="color-black">
                {bountyType == "person"
                  ? `${title} at ${company} `
                  : department}
              </p>
            </div>
            <div className="row m-0 justify-content-between mt-3">
              <span>For {reason}</span>
            </div>
          </div>
          <Form className="form p-4">
            <div className="input-field">
              <label>How do you Know Jane Doe</label>
              <Select
                placeholder="hello"
                value={relation}
                onChange={(value) => setRelation(value)}
              >
                <option value="" disabled>
                  Select your option
                </option>
                <option value="Friend">Friend</option>
                <option value="Relative">Relative</option>
                <option value="Colleague">Colleague</option>
                <option value="Acquaintance">Acquaintance</option>
                <option value="Client">Client</option>
              </Select>
            </div>
            <div className="input-field">
              <label>When can you make the Intro</label>
              <Select value={intro} onChange={(value) => setIntro(value)}>
                <option value="" disabled>
                  Select your option
                </option>
                <option value="Within 1-3 days">Within 1-3 days</option>
                <option value="Within 7 Days">Within 7 days</option>
                <option value="AnyTime">Anytime, you set the date</option>
              </Select>
            </div>
            <div className="input-field">
              <label>Additional comment</label>
              <input
                type="text"
                onChange={(event) => {
                  setComment(event.target.value);
                }}
              />
            </div>
            <div className="row d-flex signup-with">
              <div className="col-6">
                <button className="cancel" onClick={handleCancel}>
                  Cancel
                </button>
              </div>
              <div className="col-6">
                <button
                  disabled={disable}
                  onClick={submitIntro}
                  className="intro"
                >
                  <img src={Group} alt="" /> Make intro
                </button>
              </div>
            </div>
          </Form>
        </div>
      )}
    </div>
  );
};

export default IntroModal;
